module.exports = __webpack_public_path__ + "img/support.20d755c7.svg";